/**
 * Created by piotr.pozniak@thebeaverhead.com on 16/02/2022
 */

import React from "react";
import { useTranslation } from "react-i18next";

const NoEvents = (props) => {
  const { t } = useTranslation();

  return (
    <p className="events-list-container--events-empty" role="status">
      {t("No Events")}
    </p>
  );
};

export default NoEvents;
